import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { ErrorDisplay } from "@/components/core/error-display";
import { LinkButton } from "@/components/core/tanstack-link";
import { queryClient } from "@/helpers/tanstack-client";
import { useTrovePlan } from "@/hooks/trove-plan";
import { getStatusQueryKey, PricingFeature, status } from "@/models/backend";

export const Route = createFileRoute("/_authenticated/_contained/admin")({
  beforeLoad: async () => {
    const plan = await queryClient.ensureQueryData({
      queryFn: status,
      queryKey: getStatusQueryKey(),
    });
    if (plan.main_account) {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { features } = useTrovePlan();

  if (!features.includes(PricingFeature.multi_account)) {
    return (
      <ErrorDisplay title="This organization does not appear to have multi-account access">
        <LinkButton to="/dashboard">Return to dashboard</LinkButton>
      </ErrorDisplay>
    );
  }
  return <Outlet />;
}
